module.exports = __webpack_public_path__ + "static/delivery-service-f0b832537f7062c3000150ca31616375.png";